module.exports = __webpack_public_path__ + "static/logo-d59e5fe7a6c7d486b1ca056e3bf12034.png";